import arrowIcon from "@icons/chevron-right.svg";
import AgencySearch from "./modules/agencysearch.module.js";

document.addEventListener('DOMContentLoaded', () => {
    const components = document.querySelectorAll('[data-module]');

    const initializeComponent = (el) => {
        const componentName = el.dataset.module;

        if (!componentName) {
            return;
        }

        const modulePath = componentName.toLowerCase();

        import(`./modules/${modulePath}.module.js`)
            .then((Module) => {
                const ComponentClass = Module.default;
                new ComponentClass(el);
            })
            .catch((err) => {
                console.error(`Modul ${componentName} konnte nicht geladen werden:`, err);
            });
    };

    const deferredSliders = [];

    for (const el of components) {
        if (el.dataset.module === 'Slider') {
            deferredSliders.push(el);
            continue;
        }

        initializeComponent(el);
    }

    if ('IntersectionObserver' in window) {
        const sliderObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }

                observer.unobserve(entry.target);
                initializeComponent(entry.target);
            });
        }, { rootMargin: '300px 0px' });

        deferredSliders.forEach((slider) => sliderObserver.observe(slider));
    } else {
        deferredSliders.forEach(initializeComponent);
    }

    document.querySelectorAll('figure.table .contenttable').forEach(table => {
        const colCount = table.querySelectorAll('thead tr th').length;
        const figure = table.closest('figure.table');

        if (colCount <= 2) {
            figure.classList.add('no-scroll');
            return;
        }

        // arrow right
        const arrowRight = document.createElement('div');
        arrowRight.classList.add('scroll-arrow', 'scroll-arrow--right');
        arrowRight.innerHTML = `<img src="${arrowIcon}" alt="">`;
        figure.appendChild(arrowRight);

        // arrow left
        const arrowLeft = document.createElement('div');
        arrowLeft.classList.add('scroll-arrow', 'scroll-arrow--left');
        arrowLeft.innerHTML = `<img src="${arrowIcon}" alt="">`;
        figure.appendChild(arrowLeft);

        const updateArrows = () => {
            const rect = figure.getBoundingClientRect();
            const scrollLeft = figure.scrollLeft;
            const maxScroll = figure.scrollWidth - figure.clientWidth;

            // middle of the screen
            const arrowCenterY = window.innerHeight / 2;
            const offset = 50;

            // visiblity range
            const isInsideTableRange = (rect.top + offset) < arrowCenterY && (rect.bottom - offset) > arrowCenterY;

            // horizontal position
            arrowLeft.style.left = `${rect.left + 10}px`;
            arrowRight.style.left = `${rect.right - 60}px`;

            const atStart = scrollLeft <= 5;
            const atEnd = scrollLeft >= maxScroll - 5;

            // arrow right - show only on start
            if (!atEnd && isInsideTableRange) {
                arrowRight.classList.remove('is-hidden');
            } else {
                arrowRight.classList.add('is-hidden');
            }

            // arrow left - show only on end
            if (!atStart && isInsideTableRange) {
                arrowLeft.classList.remove('is-hidden');
            } else {
                arrowLeft.classList.add('is-hidden');
            }
        };

        // arrow right - scroll to end
        arrowRight.addEventListener('click', () => {
            figure.scrollBy({ left: 200, behavior: 'smooth' });
        });

        // arrow left - scroll to start
        arrowLeft.addEventListener('click', () => {
            figure.scrollBy({ left: -200, behavior: 'smooth' });
        });

        window.addEventListener('scroll', updateArrows, { passive: true });
        figure.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();
    });

    document.querySelectorAll('.file-input').forEach(function (input) {
        input.addEventListener('change', function () {

            const group = this.closest('.job__application-form-group');
            const hint = group ? group.querySelector('.upload-hint') : null;

            if (!hint) return;

            if (!this.files || this.files.length === 0) {
                hint.innerText = 'Per Klick Datei auswählen';
                return;
            }

            if (this.multiple) {
                if (this.files.length === 1) {
                    hint.innerText = this.files[0].name;
                } else {
                    const names = Array.from(this.files).map(f => f.name);
                    hint.innerText = names.join(', ');
                }
            } else {
                hint.innerText = this.files[0].name;
            }
        });
    });

    // added style for agency search
    document.querySelectorAll('.ont3-agency-search__field').forEach((field) => {
        new AgencySearch(field);
    });
});
